import { isFinanceProject } from 'config';

import { CompanyConstituentDocs } from '../components';
import { useCompanyConstituentDocs } from '../hooks';
import { PageComponentProps } from '../types';

export const CompanyConstituentDocsStep = ({
  canGoBack,
}: PageComponentProps) => {
  const {
    files,
    initialValues,
    onAddFiles,
    onRemoveFile,
    onSubmit,
    submitDisabled,
    submitLoading,
    goToBack,
  } = useCompanyConstituentDocs();

  return (
    <CompanyConstituentDocs
      canGoBack={canGoBack}
      enabledDateOfLastChange={isFinanceProject()}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
